import { ReactNode, ElementType } from 'react';

import { getFlexStyles, SpacingToken, ResponsiveCols } from './helpers/layout';

export interface ContainerProps {
  as?: ElementType;
  direction?: 'horizontal' | 'vertical';
  gap?: SpacingToken;
  padding?: SpacingToken;
  py?: SpacingToken;
  px?: SpacingToken;
  pt?: SpacingToken;
  pb?: SpacingToken;
  pl?: SpacingToken;
  pr?: SpacingToken;
  gapX?: SpacingToken;
  gapY?: SpacingToken;
  displayGrid?: boolean;
  gridCols?: number | string | ResponsiveCols;
  gridRows?: number | string | ResponsiveCols;
  m?: SpacingToken;
  my?: SpacingToken;
  mx?: SpacingToken;
  mt?: SpacingToken;
  mb?: SpacingToken;
  align?: 'start' | 'center' | 'end' | 'baseline' | 'stretch';
  justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
  fullWidth?: boolean;
  maxWidth?: string;
  centered?: boolean;
  shadow?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'inner';
  blur?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  background?: 'surface' | 'primary' | 'secondary' | 'accent' | 'transparent';
  border?: boolean | 'divider' | 'primary' | 'secondary';
  borderRadius?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  position?: 'static' | 'fixed' | 'absolute' | 'sticky' | 'relative';
  top?: number | string;
  right?: number | string;
  bottom?: number | string;
  left?: number | string;
  zIndex?: number | string;
  display?:
    | 'flex'
    | 'inline-flex'
    | 'grid'
    | 'inline-grid'
    | 'block'
    | 'inline-block'
    | 'inline'
    | 'none';
  overflow?: 'auto' | 'hidden' | 'visible' | 'scroll';
  width?: string | number;
  height?: string | number;
  opacity?: number | string;
  hideOn?: 's' | 'm' | 'l';
  showOn?: 's' | 'm' | 'l';
  hideOnPrint?: boolean;
  children?: ReactNode;
  id?: string;
  style?: React.CSSProperties;
}

export const Container = ({
  id,
  as: Component = 'div',
  direction = 'vertical',
  gap,
  padding,
  py,
  px,
  pt,
  pb,
  pl,
  pr,
  gapX,
  gapY,
  displayGrid,
  gridCols,
  gridRows,
  m,
  my,
  mx,
  mt,
  mb,
  align,
  justify,
  fullWidth,
  maxWidth,
  centered,
  shadow,
  blur,
  background,
  border,
  borderRadius,
  position,
  top,
  right,
  bottom,
  left,
  width,
  height,
  zIndex,
  display,
  overflow,
  opacity,
  hideOn,
  showOn,
  hideOnPrint,
  children,
  style,
}: ContainerProps) => {
  const styles = getFlexStyles({
    direction,
    gap,
    padding,
    py,
    px,
    pt,
    pb,
    pl,
    pr,
    gapX,
    gapY,
    displayGrid,
    gridCols,
    gridRows,
    m,
    my,
    mx,
    mt,
    mb,
    align,
    justify,
    fullWidth,
    maxWidth,
    centered,
    shadow,
    blur,
    background,
    border,
    borderRadius,
    position,
    top,
    right,
    bottom,
    left,
    zIndex,
    overflow,
    width,
    height,
    opacity,
    hideOn,
    showOn,
    hideOnPrint,
    display,
  });

  return (
    <Component id={id} className={styles} style={{ width, height, ...style }}>
      {children}
    </Component>
  );
};
